<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="brc_custname"
      placeholder="输入客户进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/billar_change/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.brc_custname}}</p>
          <p class="list-item-muted">{{item.brc_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.brc_amount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.brc_status!='已审核'}"
          >{{item.brc_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('brc_amount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    
    return {
      listUrl: "/api/money/billarchange/list",
      filters: [
        {
          type: "date",
          name: "brc_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          // beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
          ]
        }
      ]
    };
  },
  
};
</script>